import { render, staticRenderFns } from "./ReviewsCategoriesLegend.vue?vue&type=template&id=f1c858a4&scoped=true&"
import script from "./ReviewsCategoriesLegend.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesLegend.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesLegend.vue?vue&type=style&index=0&id=f1c858a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c858a4",
  null
  
)

export default component.exports